import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import { analyticsTrack } from '../../../analyticsUtils';
import './ProfileCompletion.scss';

const redirectToProfile = (userPath, location) => {
  analyticsTrack('Clicked on Profile Completion Card button', { location });
  window.location.href = userPath;
};

function ProfileCompletion({
  header, subtext, percentage, userPath, location, banner, small,
}) {
  if (percentage < 100) {
    if (small) {
      return (
        <div className="profile-completion-small body-text-3 demibold">
          <div className="header">
            <div>{header}</div>
            {subtext && <div className="normal-weight">{subtext}</div>}
          </div>
          <div className="g-column g-row-left-align">
            <div className="g-row--always">
              <div className="bar"><ProgressBar now={percentage} /></div>
              <div className="percent">
                {percentage}
                %
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={`profile-completion-card ${banner ? 'banner' : ''}`}>
        <div className="cta">
          <h1 className="bold mb-8">Strengthen your profile!</h1>
          <div className="body-text-2">{header}</div>
          {userPath && banner
            && (
            <button
              className="btn btn-quaternary bigger-button profile-completion-link mt-4"
              onClick={() => redirectToProfile(userPath, location)}
            >
              Complete Profile
            </button>
            )}
        </div>
        <div className="progress-container">
          <div className="progress progress-circle" data-percentage={percentage}>
            <span className="progress-left">
              <span className="progress-bar" />
            </span>
            <span className="progress-right">
              <span className="progress-bar" />
            </span>
            <div className="progress-value mx-auto">
              <h1>
                {percentage}
                %
              </h1>
            </div>
          </div>
          <div className="body-text-3 demibold mt-12">Profile Completion</div>
        </div>
        {userPath
          && (
          <button
            className="btn btn-quaternary bigger-button full-width
            full-width-profile-completion-link"
            onClick={() => redirectToProfile(userPath, location)}
          >
            Complete Profile
          </button>
          )}
      </div>
    );
  }
  return null;
}

ProfileCompletion.propTypes = {
  header: PropTypes.string.isRequired,
  subtext: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  userPath: PropTypes.string,
  location: PropTypes.string,
  banner: PropTypes.bool,
  small: PropTypes.bool,
};

ProfileCompletion.defaultProps = {
  userPath: null,
  location: '',
  banner: false,
  small: false,
  subtext: null,
};

export default ProfileCompletion;
